import { render, staticRenderFns } from "./VideoParallax3.vue?vue&type=template&id=67ab91f6&scoped=true"
import script from "./VideoParallax3.vue?vue&type=script&lang=js"
export * from "./VideoParallax3.vue?vue&type=script&lang=js"
import style0 from "./VideoParallax3.vue?vue&type=style&index=0&id=67ab91f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab91f6",
  null
  
)

export default component.exports